import React from 'react';
import { MapPin } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LocationFallbackProps {
  displayName: string;
  locationText?: string | null;
  className?: string;
}

const LocationFallback: React.FC<LocationFallbackProps> = ({ 
  displayName, 
  locationText,
  className 
}) => (
  <div className={cn(
    "location-fallback flex items-center gap-2 p-3 max-sm:p-2 bg-muted/50 rounded-md border border-border/50",
    className
  )}>
    <MapPin className="h-4 w-4 max-sm:h-3 max-sm:w-3 text-muted-foreground shrink-0" />
    <div className="text-sm max-sm:text-xs text-muted-foreground truncate">
      {locationText || 'Location not specified'}
    </div>
  </div>
);

export default LocationFallback;